/** #################################### Generated content ####################################
 * This block has been generated with deppy create-index (for more information https://github.com/webedx-spark/deppy)
 **/

export {
  SkillSetsAddedNotification,
  SkillSetsRemovedNotification,
  SkillSetRenamedSuccessfullyNotification,
  UpdatedSkillSetDescriptionSuccessfullyNotification,
} from './components/Notifications';
export { default as SkillSetSelectionOverlay } from './components/SkillSetSelectionOverlay';
export { default as SkillSetSelection } from './components/SkillSetSelection';
export { Card, CardContent, Footer, getGoalType, default as SkillSetCard } from './components/SkillSetCard';
export { SkillSetCardHeader } from './components/SkillSetCardHeader';
export { ExtraProficiencies, Proficiencies, ProficiencyRow } from './components/SkillSetCardProficiencies';
export { getSkillSetAcademies, dataTechAcademyIds, matchDataTechAcademies } from './utils/academies';
export type { PropsFromWithSkillsData } from './hocs/withSkillsData';
export { withSkillsData } from './hocs/withSkillsData';
export { default as SkillSetBankPage } from './components/SkillSetBankPage';
export const SkillSetBankPageDynamic = () => import('./components/SkillSetBankPage');

/**
 *  #################################### Generated content ####################################
 **/
